import React from 'react';
import classNames from 'classnames';
import { IHasTestData } from 'ui-toolkit/test-utilities/IHasTestData';
import { SpinnerSize } from 'ui-toolkit/components/Spinner/Spinner';
import { mergeTests } from 'ui-toolkit/test-utilities/mergeTests';

export interface SpinnerProps extends IHasTestData {
  className?: string;
  size?: SpinnerSize;
}

const stylesDict = {
  [SpinnerSize?.tiny]: 'border-2 h-2 w-2',
  [SpinnerSize?.small]: 'border-2 h-4 w-4',
  [SpinnerSize?.regular]: 'border-4 h-6 w-6',
  [SpinnerSize?.large]: 'border-4 h-8 w-8',
  [SpinnerSize?.huge]: 'border-4 h-12 w-12',
};

const getSize = (size?: SpinnerSize): string => {
  if (!size) return 'border-4 h-6 w-6';
  return stylesDict[size];
};

export const SpinnerTW: React.FC<SpinnerProps> = ({ className, size, ...rest }) => {
  return (
    <div
      className={classNames(
        'z-10 animate-spin rounded-full border border-solid border-slate-800 border-l-transparent',
        getSize(size),
        className
      )}
      data-test-id={mergeTests(rest['data-test-id'], 'spinner-tw')}
      data-test-class={mergeTests(rest['data-test-id'], 'spinner-tw')}
    />
  );
};
